import React from "react";
import "./header.css";
import HeaderSocials from "./HeaderSocials";
import LandingAnimation from "./LandingAnimation";
const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <LandingAnimation />
        <HeaderSocials />
        <a href="#contacts" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
